// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__35QM8","col":"styles_col__3tr9E"};